export default "__VITE_ASSET__CWLA7eoW__"